import createReducer from 'utils/redux/createReducer'
import * as R from 'ramda'

const initialState = "view"

let checkMode = (mode, action) => {
    if (mode == "view") return false
    else return action
}

let stage = (currentState, action, megastate) => {
      let buffer = (action || {}).data || {}
      let data = (megastate || {}).data.db[buffer._id] || {}
      //buffer = {...data, ...buffer}  R.equals(data, buffer)
      //delete buffer._id
      if(currentState=="new" || currentState=="creating") return "creating"
      if(currentState=="view") {
          for (let key in buffer){
              //console.log(buffer[key], data[key]);
              if (!R.equals(buffer[key], data[key]) && (!data[key] != !buffer[key] || !!data[key])) return "edit"
          }
          return "view"
      }
      return currentState
 }

export default createReducer(initialState, {
    ADD: (currentState, action) => {
        if (currentState == "view") return "creating"
        else return currentState
    }
  , NEW_PAYMENT: (currentState, action) => {
      if (currentState == "view") return "creating"
      else return currentState
    }
  , COMMIT: (currentState, action) => "view"
  , OK: (currentState, action) => "view"
  , CLOSE: (currentState, action) => {
        if (currentState == "new") {
            return "view"
        }
        return currentState
    }
  , CLOSE_YES: (currentState, action) => "view"
  , ROLLBACK: (currentState, action) => "view"
  , DELETE_YES: (currentState, action) => "view"
  , DOC_DELETE: (currentState, action) => "view"
  , STAGE: stage
  , LINE_ADD: stage
  , '@@router/LOCATION_CHANGE': (currentState, action) => {
        if (currentState == "new") {
          return "view"
        }
        return currentState
   }
})



// WEBPACK FOOTER //
// ./src/reducers/mode.js